var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vscode-icons:file-type-excel",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.019 11.7271L6.71729 10.2646V21.0714C6.71738 21.1888 6.7406 21.305 6.78562 21.4135C6.83064 21.5219 6.89658 21.6204 6.97966 21.7033C7.06275 21.7863 7.16136 21.852 7.26986 21.8969C7.37836 21.9417 7.49463 21.9647 7.61204 21.9646H21.937C22.0546 21.9649 22.171 21.9421 22.2797 21.8973C22.3883 21.8526 22.4871 21.7868 22.5704 21.7039C22.6536 21.6209 22.7197 21.5223 22.7648 21.4138C22.8099 21.3053 22.8332 21.1889 22.8333 21.0714V17.0896L15.019 11.7271Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.019 2.46484H7.61204C7.49463 2.46475 7.37836 2.48777 7.26986 2.53261C7.16136 2.57745 7.06275 2.64321 6.97966 2.72616C6.89658 2.80911 6.83064 2.9076 6.78562 3.01603C6.7406 3.12446 6.71738 3.24069 6.71729 3.35809V7.33984L15.019 12.2148L19.4148 13.6773L22.8333 12.2148V7.33984L15.019 2.46484Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.71729 7.33984H15.019V12.2148H6.71729V7.33984Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.1,
    d: "M12.6588 6.36523H6.71729V18.5527H12.6588C12.8955 18.5516 13.1223 18.4571 13.2899 18.2899C13.4575 18.1227 13.5525 17.8962 13.5543 17.6595V7.25848C13.5525 7.02174 13.4575 6.79523 13.2899 6.62803C13.1223 6.46083 12.8955 6.36641 12.6588 6.36523Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.2,
    d: "M12.1705 6.85254H6.71729V19.04H12.1705C12.4073 19.0389 12.634 18.9444 12.8017 18.7772C12.9693 18.61 13.0643 18.3835 13.066 18.1468V7.74579C13.0643 7.50904 12.9693 7.28253 12.8017 7.11533C12.634 6.94813 12.4073 6.85372 12.1705 6.85254Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.2,
    d: "M12.1705 6.85254H6.71729V18.065H12.1705C12.4073 18.0639 12.634 17.9694 12.8017 17.8022C12.9693 17.635 13.0643 17.4085 13.066 17.1718V7.74579C13.0643 7.50904 12.9693 7.28253 12.8017 7.11533C12.634 6.94813 12.4073 6.85372 12.1705 6.85254Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.2,
    d: "M11.6823 6.85254H6.71729V18.065H11.6823C11.919 18.0639 12.1458 17.9694 12.3134 17.8022C12.481 17.635 12.576 17.4085 12.5778 17.1718V7.74579C12.576 7.50904 12.481 7.28253 12.3134 7.11533C12.1458 6.94813 11.919 6.85372 11.6823 6.85254Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.72875 6.85254H11.6823C11.9194 6.85234 12.147 6.94631 12.3149 7.11381C12.4828 7.28131 12.5774 7.50862 12.5778 7.74579V16.6843C12.5774 16.9215 12.4828 17.1488 12.3149 17.3163C12.147 17.4838 11.9194 17.5777 11.6823 17.5775H2.72875C2.61129 17.5777 2.49493 17.5548 2.38635 17.51C2.27776 17.4652 2.17906 17.3994 2.09589 17.3165C2.01273 17.2335 1.94673 17.135 1.90166 17.0265C1.8566 16.918 1.83335 16.8018 1.83325 16.6843V7.74579C1.83335 7.62833 1.8566 7.51203 1.90166 7.40355C1.94673 7.29508 2.01273 7.19655 2.09589 7.11359C2.17906 7.03064 2.27776 6.96488 2.38635 6.92009C2.49493 6.8753 2.61129 6.85234 2.72875 6.85254Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M4.60815 15.12L6.4914 12.207L4.7664 9.31055H6.15165L7.0929 11.1653C7.1799 11.3408 7.2429 11.4713 7.2714 11.5583H7.28415C7.34565 11.4173 7.4109 11.2815 7.47915 11.1488L8.48565 9.31355H9.76065L7.9914 12.1935L9.80565 15.1223H8.4489L7.3614 13.089C7.31091 13.0016 7.268 12.91 7.23315 12.8153H7.21515C7.18344 12.9076 7.14116 12.9959 7.08915 13.0785L5.9694 15.12H4.60815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M21.9378 2.46485H15.019V7.33985H22.8333V3.35809C22.8332 3.24063 22.8099 3.12434 22.7649 3.01586C22.7198 2.90738 22.6538 2.80885 22.5707 2.7259C22.4875 2.64294 22.3888 2.57719 22.2802 2.53239C22.1716 2.4876 22.0553 2.46465 21.9378 2.46485Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15.019 12.2148H22.8333V17.0898H15.019V12.2148Z",
    fill: "#667085"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.118a7494c6025d6461dbdd046460811f.svg";
export { ForwardRef as ReactComponent };